// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FeaturesVerticalSlide(Props) {
  const intl = ReactIntl.useIntl();
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    return "border-l-4 border-warning pl-5 lg:w-96 sticky top-25 h-full px-6";
  });
  const textRef = React.useRef(null);
  const taxesPhotoRef = React.useRef(null);
  const bankPhotoRef = React.useRef(null);
  React.useEffect((function () {
    const textElement = textRef.current;
    const __x = (textElement == null) ? undefined : Caml_option.some(textElement);
    return Belt__Belt_Option.map(__x, (function (el) {
      el.classList.add("animate-fadeInSlow");
      const remove = setTimeout((function (param) {
        el.classList.remove("animate-fadeInSlow");
      }), 400);
      return function (param) {
        clearTimeout(remove);
      };
    }));
  }), [idx]);
  const applyClasses = function (param) {
    const taxesPh = taxesPhotoRef.current;
    const bankPh = bankPhotoRef.current;
    if (taxesPh == null) {
      return;
    }
    if (bankPh == null) {
      return;
    }
    const taxesTop = taxesPh.getBoundingClientRect().top;
    const bankTop = bankPh.getBoundingClientRect().top;
    if (bankTop < 600) {
      return Curry._1(setIdx, (function (param) {
        return 2;
      }));
    } else if (taxesTop < 600) {
      return Curry._1(setIdx, (function (param) {
        return 1;
      }));
    } else {
      return Curry._1(setIdx, (function (param) {
        return 0;
      }));
    }
  };
  const handleScroll = function (param) {
    applyClasses(undefined);
  };
  React.useEffect((function () {
    applyClasses(undefined);
    window.addEventListener("scroll", handleScroll);
    return (function (param) {
      window.removeEventListener("scroll", handleScroll);
    });
  }), []);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const match$2 = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match$2[0].homePage;
  const features_0 = {
    title: homePage.carousel_item_title_1,
    subtitle: homePage.carousel_item_text_1,
    description: homePage.carousel_item_subtext_1,
    route: {
      TAG: /* Landing */ 0,
      _0: Buhta_landing__Route.getCountry(undefined),
      _1: language,
      _2: /* Kassa */ 13
    }
  };
  const features_1 = {
    hd: {
      title: homePage.carousel_item_title_2,
      subtitle: homePage.carousel_item_text_2,
      description: homePage.carousel_item_subtext_2,
      route: {
        TAG: /* Landing */ 0,
        _0: Buhta_landing__Route.getCountry(undefined),
        _1: language,
        _2: /* Home */ 0
      }
    },
    tl: {
      hd: {
        title: homePage.carousel_item_title_3,
        subtitle: homePage.carousel_item_text_3,
        description: homePage.carousel_item_subtext_3,
        route: {
          TAG: /* Landing */ 0,
          _0: Buhta_landing__Route.getCountry(undefined),
          _1: language,
          _2: /* Home */ 0
        }
      },
      tl: /* [] */ 0
    }
  };
  const features = {
    hd: features_0,
    tl: features_1
  };
  const activeFeature = Stdlib__List.nth(features, idx);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          ref: textRef,
          children: [
            JsxRuntime.jsx("h2", {
              children: activeFeature.title,
              className: "h5 title text-white"
            }),
            JsxRuntime.jsx("h3", {
              children: activeFeature.subtitle,
              className: "h-light text-white mt-2"
            }),
            JsxRuntime.jsx("p", {
              children: activeFeature.description,
              className: "paragraph-large opacity-64 desc text-white mt-4"
            }),
            JsxRuntime.jsxs(Buhta_landing__Link.make, {
              route: activeFeature.route,
              className: "link block paragraph cursor-pointer link-hover text-white mt-4",
              children: [
                Buhta_landing__I18n.trans(intl, "learn_more"),
                JsxRuntime.jsx("img", {
                  className: "inline ml-1",
                  src: StaticAsset.src("/static/icons/forward.svg")
                })
              ]
            })
          ],
          className: match$1[0]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                className: "-mr-18 w-156 max-w-none",
                alt: "buhta",
                src: StaticAsset.src("/static/images/ui.png")
              }),
              className: "mb-50 last:mb-25"
            }),
            JsxRuntime.jsx("div", {
              ref: taxesPhotoRef,
              children: JsxRuntime.jsx("img", {
                className: "-mr-18 w-156 max-w-none",
                alt: "taxes",
                src: StaticAsset.src("/static/images/taxes.png")
              }),
              className: "mb-50 last:mb-25"
            }),
            JsxRuntime.jsx("div", {
              ref: bankPhotoRef,
              children: JsxRuntime.jsx("img", {
                className: "-mr-18 w-156 max-w-none",
                alt: "bank",
                src: StaticAsset.src("/static/images/bank.png")
              }),
              className: "mb-50 last:mb-25"
            })
          ]
        })
      ],
      className: "flex m-auto mt-10 w-252 justify-between"
    }),
    className: "flex justify-center mt-20"
  });
}

const make = FeaturesVerticalSlide;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
